import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../../common/constants";
import { listApprovalAlertUrl } from "../../../config";
import api from "../../../api";
import { checkAlertCount } from "./utils";
import { IListAlertState } from "../../../common/types/alertsTypes";

const LIST_APPROVAL_ALERT: string = "listApprovalAlert"

const initialState: IListAlertState = {
  status: Status.IDLE,
  error: null,
  data: null,
};

export const listApprovalAlert = createAsyncThunk(LIST_APPROVAL_ALERT, async () => {
  try {
    const response = await api.get(listApprovalAlertUrl + `?orgId=${DefaultTopLevelGroup.ID}`);
        return response.data;
  } catch (error) {
    throw error;
  }
});

const listApprovalAlertSlice = createSlice({
  name: LIST_APPROVAL_ALERT,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
        builder
            .addCase(listApprovalAlert.pending, (state) => {
                state.status = Status.PENDING;
            })
            .addCase(listApprovalAlert.fulfilled, (state, action) => {
                state.status = Status.SUCCESS;
                state.data = action.payload.values.filter(alert => checkAlertCount(alert));
            })
            .addCase(listApprovalAlert.rejected, (state, action) => {
                state.msg = action.error.message
                state.status = Status.FAILED;
            });
    },
});

type Selector = {
  listApprovalAlertApi: ReturnType<
    typeof listApprovalAlertSlice.reducer
  >;
};

export const selector = (store: Selector) => store['listApprovalAlertApi'];

export default listApprovalAlertSlice.reducer;